module.exports = __webpack_public_path__ + "static/media/Daily_Pleasure1.8c94410f.mp3";